import { Checkbox } from 'antd';
import MyTable from 'components/UIElements/MyTable';
import { useParams, useLocation } from 'react-router-dom';
import EndPoints from 'shared/endPoints/EndPoints.json';
import { AuthContext } from 'shared/context/auth-context';
import React, { useContext } from 'react';
import getSharedTripColumns from './sharedTripColumns';

export default function Trips() {
  const { id } = useParams();
  const endPoint = `${EndPoints.CONTRACT.GETTRIPS}/?contractId=${id}`;
  const location = useLocation();
  const exportFilename = ` Anytime_BTM_Trip_History_Contract_${location.state.policyNumber}`;
  const { roleUser } = useContext(AuthContext);
  const allRoles = ['AnyTimeAdmin', 'AnyTime', 'GT'];

  const columns = [
    ...getSharedTripColumns(allRoles),
    {
      title: 'Deleted',
      key: 'isActive',
      render: ({ isActive: record }) => <Checkbox checked={record !== '1'} />,
      showOnRoles: ['AnyTimeAdmin']
    },
    {
      title: 'DeleteInfo',
      key: 'deleteType',
      dataIndex: 'deleteType',
      showOnRoles: ['AnyTimeAdmin']
    },
    {
      title: 'Comments',
      key: 'deleteComments',
      dataIndex: 'deleteComments',
      showOnRoles: ['AnyTimeAdmin']
    }
  ].filter(item => item.showOnRoles.indexOf(roleUser) !== -1);

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
      ContractTab
      expandable
    />
  );
}
